import { LoginLogo } from "@/shared/components/common/icons";
import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import { Grid } from "@mui/material";
import { useState, useEffect } from "react";
import FormLogin from "./formLogin";
import FormForgetPassword from "./formForgetPassword";
import FormRegister from "./formRegister";
import OtpRegister from "./otpRegister";

/**
 * Login
 *
 * کامپوننت مربوط به صفحه ورود، ثبت‌نام، فراموشی رمز عبور و تأیید OTP.
 * این کامپوننت با استفاده از چند state داخلی وضعیت فرم مورد نیاز
 * را مدیریت می‌کند و فرم مناسب را به کاربر نمایش می‌دهد.
 *
 * ساختار صفحه:
 * - نیمه چپ: نمایش فرم ورود، ثبت‌نام، فراموشی رمز عبور و OTP
 * - نیمه راست: پنل برند شامل لوگو و پیام‌های تبلیغاتی
 *
 * ویژگی‌ها:
 * - کاملاً ریسپانسیو برای نمایش در دسکتاپ و موبایل
 * - مدیریت جریان ثبت‌نام و OTP با استفاده از state
 * - جدا کردن بخش فرم‌ها و بخش برند برای سازمان‌دهی بهتر UI
 * - پاکسازی کامل localStorage هنگام ورود به صفحه
 * - پشتیبانی از referral code در URL برای نمایش خودکار فرم ثبت‌نام
 *
 * @returns JSX.Element
 */

const Login = () => {
    const [isRegister, setIsRegister] = useState(false);
    const [isForgetPassword, setIsForgetPassword] = useState(false);
    const [isOtpRegister, setIsOtpRegister] = useState(false);
    const [phoneNumberRegister, setStatePhoneNumberRegister] = useState<any>("");
    const [nidRegister, setStateNidRegister] = useState<any>("");
    const [passRegister, setStatePassRegister] = useState<any>("");
    const [resetPassRegister, setStateResetPassRegister] = useState<any>("");
    const [indRegister, setIndRegister] = useState<any>();
    const [referralCode, setReferralCode] = useState<string | null>(null);

    // Check for ref parameter in URL and auto-show registration form
    useEffect(() => {
        // Get URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        const ref = urlParams.get('ref');

        if (ref) {
            // Store the referral code if needed for the registration process
            setReferralCode(ref);
            // Automatically show registration form
            setIsRegister(true);
            setIsForgetPassword(false);
            setIsOtpRegister(false);

            // Optional: Log or track the referral
            // console.log('User came with referral code:', ref);
        }
    }, []); // Empty dependency array means this runs once when component mounts

    // Clear all localStorage when the login page loads
    // useEffect(() => {
    // Clear all localStorage items
    // localStorage.clear();

    // Optional: If you want to keep specific items, you can remove them individually
    // localStorage.removeItem('token');
    // localStorage.removeItem('userType');
    // localStorage.removeItem('refreshToken');
    // etc.

    // console.log('LocalStorage cleared on login page load');
    // }, []); // Empty dependency array means this runs once when component mounts

    return (
        <Grid container sx={{padding: "15px",minHeight: "100vh",width:"100%",justifyContent:'center'}} spacing={2}>
            {/* Left Section (Forms) */}
            <Grid size={{xs:12,md:6}} sx={{display: "flex",flexDirection:'column',minHeight: { xs: "auto", md: "98svh" },justifyContent: "center",alignItems: "center",paddingY: { xs: 4, md: 0 },}}>
                <StackKit sx={{display:{xs:'block',sm:'block',md:'none'},}}>
                    <LoginLogo />
                </StackKit>
                {!isRegister && !isForgetPassword && !isOtpRegister ? (
                    <FormLogin
                        setIsRegister={setIsRegister}
                        setIsForgetPassword={setIsForgetPassword}
                    />
                ) : isForgetPassword ? (
                    <FormForgetPassword
                        setIsRegister={setIsRegister}
                        setIsForgetPassword={setIsForgetPassword}
                    />
                ) : !isOtpRegister ? (
                    <FormRegister
                        setIsRegister={setIsRegister}
                        setIsOtpRegister={setIsOtpRegister}
                        setStatePhoneNumberRegister={setStatePhoneNumberRegister}
                        setIndRegister={setIndRegister}
                        setStateNidRegister={setStateNidRegister}
                        setStateResetPassRegister={setStateResetPassRegister}
                        setStatePassRegister={setStatePassRegister}
                        referralCode={referralCode}
                    />
                ) : (
                    <OtpRegister
                        setIsRegister={setIsRegister}
                        setIsOtpRegister={setIsOtpRegister}
                        setIsForgetPassword={setIsForgetPassword}
                        phoneNumberRegister={phoneNumberRegister}
                        resetPassRegister={resetPassRegister}
                        passRegister={passRegister}
                        nidRegister={nidRegister}
                    />
                )}
            </Grid>

            {/* Right Section (Brand Panel) */}
            <Grid size={{xs:12,md:6}} sx={{display:{xs:'none',sm:'none',md:'flex'},minHeight: { xs: "auto", md: "98svh" },justifyContent: "center",alignItems: "center",paddingY: { xs: 4, md: 0 },}}
            >
                <StackKit
                    sx={{
                        background:"radial-gradient(91.24% 127.93% at 55.79% -18.95%, rgba(154, 0, 144, 0.5) 25.78%, rgba(41, 36, 94, 0.43) 74.34%, #1C1A34 99.04%)",
                        justifyContent: "center",
                        alignItems: "center",
                        height: { xs: "auto", md: "95svh" },
                        padding: { xs: "40px 20px", sm: "60px 20px" },
                        width: "100%",
                        borderRadius: "10px",
                        textAlign: "center",
                    }}
                >
                    <StackKit sx={{height: { xs: "auto", md: "80svh" }, justifyContent: "center", alignContent: "center", gap: 6,width:350}}>
                        <LoginLogo />
                        <StackKit direction={{ xs: "column", sm: "row" }} gap={{ xs: 2, sm: 5 }} justifyContent="center" alignItems="center" sx={{ width: "100%" }}>
                            <TypoGraphyKit variant="h6">سریع</TypoGraphyKit>
                            <TypoGraphyKit variant="h6">امن</TypoGraphyKit>
                            <TypoGraphyKit variant="h6">آسان</TypoGraphyKit>
                        </StackKit>
                    </StackKit>

                    <StackKit alignItems="center">
                        <TypoGraphyKit variant="body1">سامانه پرداختی و اعتباری</TypoGraphyKit>
                    </StackKit>
                </StackKit>
            </Grid>
        </Grid>

    );
};

export default Login;